import React from 'react';

const Ring = ({ color, dashed, filled }) => (
  <span className="relative w-4 h-4 shrink-0 rounded-full flex items-center justify-center"
    style={{ border: `2px ${dashed ? 'dashed' : 'solid'} ${color}`, boxShadow: dashed ? 'none' : `0 0 0 2px ${color}55` }}>
    {filled && <span className="w-2.5 h-2.5 rounded-full" style={{ background: color, opacity: 0.8 }} />}
  </span>
);

const ITEMS = [
  { id: 'verified', ring: <Ring color="#E8C15A" dashed />, label: 'Soggetto verificato', text: 'incluso nel reputational check' },
  { id: 'ubo', ring: <Ring color="#D4AF37" />, label: 'Titolare effettivo', text: 'possiede più del 25%, anche tramite altre società' },
  { id: 'ubo-hit', ring: <Ring color="#E5484D" filled />, label: 'Titolare effettivo con riscontri', text: 'il reputational check ha trovato riscontri: approfondire' },
];

export default function GraphColorLegend({ aml = [] }) {
  return (
    <div className="mt-3 p-4 border border-[#1F242C] rounded-sm" data-testid="graph-color-legend">
      <p className="text-[11px] uppercase tracking-[0.16em] text-[#8A8F97] mb-3">Legenda dei colori</p>
      <div className="grid sm:grid-cols-3 gap-3">
        {ITEMS.map((i) => (
          <div key={i.id} className="flex items-start gap-2.5" data-testid={`graph-legend-${i.id}`}>
            <span className="mt-0.5">{i.ring}</span>
            <span className="text-xs"><b className={`block ${i.id === 'ubo-hit' ? 'text-[#FF6B6E]' : 'text-[#E5E5E5]'}`}>{i.label}</b><span className="text-[#8A8F97]">{i.text}</span></span>
          </div>
        ))}
      </div>
      {aml.length > 0 && (
        <div className="flex flex-wrap gap-x-5 gap-y-2 mt-3 pt-3 border-t border-[#1F242C]">
          {aml.map(([color, label]) => <span key={label} className="flex items-center gap-2 text-xs text-[#A3A3A3]"><span className="w-4 h-0.5" style={{ background: color }} />{label}</span>)}
        </div>
      )}
    </div>
  );
}
